import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Navigation } from "./components/Navigation";
import Header from "./components/SliderComponent";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import Services from "./components/Services";
import "./App.css";
import Specialities from "./components/Specialities";
import WhyUs from "./components/WhyUs";
import Features from "./components/Features";
import Expertise from "./components/Expertise";
import AboutUs from "./components/AboutUs";
import Ayurvedham from "./components/Ayurvedham";
import ContactUs from "./components/ContactUs";
import TopBar from "./components/Top";
import BackToTop from "./components/BackToTop";
// NEW: modal + floating button imports
import BookingModal from "./components/BookingModal";
import FloatingBookButton from "./components/FloatingBookButton";
import GuideView from "./components/GuideView";



export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
  offset: 100, // 👈 height of your navbar
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState({});
  const [showBookingModal, setShowBookingModal] = useState(false);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <BrowserRouter>
  <Routes>

    {/* ✅ GUIDE DOWNLOAD (specific route first) */}
    <Route path="/guide" element={<GuideView/>} />
    

    {/* ✅ MAIN WEBSITE (catch-all) */}
    <Route
      path="/*"
      element={
        <div>
          <TopBar />
          <Navigation data={landingPageData.Navigation} />
          <Header />
          <Services data={landingPageData.Services} />
          <Specialities />
          <Features data={landingPageData.Features} />
          <WhyUs />
          <Expertise />
          <AboutUs data={landingPageData.About} />
          <Ayurvedham />
          <ContactUs data={landingPageData.ContactUs} />
          <BackToTop />

          <FloatingBookButton
            isModalOpen={showBookingModal}
            setIsModalOpen={setShowBookingModal}
          />

          <BookingModal
            isOpen={showBookingModal}
            onClose={() => setShowBookingModal(false)}
          />
        </div>
      }
    />

  </Routes>
</BrowserRouter>

  );
};

export default App;

